import type { FC } from 'react';

import { DynamicImage } from '@wwe-portal/ui/components/dynamic-image';

import type { OfferItem } from '../type';
import { RosterItemStar } from './roster-item-star';
import {
  parseOfferItemDescription,
  parseRosterOfferItemStats,
} from '@wwe-portal/utils/offer/helper';

const SingleItem: FC<{ data: OfferItem }> = ({ data }) => {
  const item = data;
  const rosterItemStats = parseRosterOfferItemStats({
    description: item.description,
    text: item.text,
    itemId: item.itemId,
  });

  return (
    <div
      className="flex flex-col items-center gap-4 px-9 pb-6 pt-2"
      data-id={data.itemId}
    >
      <div className="relative h-[84px] w-full flex-1">
        <DynamicImage
          alt={data.itemId}
          className="h-[84px] w-full object-contain"
          defaultUrl={data.defaultImageUrl}
          dynamicUrl={data.dynamicImageUrl}
          resizedWidth={128}
        />
        <RosterItemStar stats={rosterItemStats} />
      </div>
      <div className="font-poppins text-text500 flex-1 basis-16 py-[6px] text-base font-semibold text-[#E3E7F4]">
        {parseOfferItemDescription({
          description: item.description,
          text: item.text,
          stats: rosterItemStats,
        })}
      </div>
    </div>
  );
};

export default SingleItem;
